/**
 * Override ./src/lib/ui/utils.tsx
 */

export const AppDateTimePickerDefaults = {
  DateTimeFormat: 'YYYY.MM.DD HH:mm',
  DateFormat: 'YYYY.MM.DD',
};
